// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.

export default {
  type: 'dark',
  primary: {
    main: '#a4bfe4',
    light: '#d6f2ff',
    dark: '#748fb2',
    contrastText: '#000000',
  },
  secondary: {
    main: '#ffe26b',
    dark: '#c9b03a',
    light: '#ffff9c',
    contrastText: '#000000',
  },
  tertiary: {
    main: '#baa3c8',
    contrastText: '#000000',
  },
  error: {
    main: '#e57373',
    dark: '#A05050',
    light: '#EA8F8F',
    contrastText: '#000000',
  },
  warning: {
    main: '#ffa726',
    dark: '#f57c00',
    light: '#ffb74d',
    contrastText: '#000000',
  },
  info: {
    main: '#67B8E3',
    dark: '#48809E',
    light: '#85C6E8',
    contrastText: '#000000',
  },
  success: {
    main: '#66bb6a',
    dark: '#388e3c',
    light: '#81c784',
    contrastText: '#000000',
  },
  microsoft: {
    main: '#2F2F2F',
    contrastText: '#FFFFFF',
  },
  appbar: {
    main: '#121212',
    contrastText: '#FFFFFF',
    contrastTextSoft: 'rgba(255, 255, 255, 0.7)',
  },
  login: {
    main: '#2F363B',
  },
};
